/**
 * Authenticated fetch wrapper for Heyward API calls.
 * Automatically attaches Clerk JWT to every request.
 *
 * Usage:
 *   import { authFetch } from '../utils/authFetch';
 *   const res = await authFetch('/api/v1/deals');
 */

let _getAuthToken = null;

export function setAuthTokenProvider(getAuthToken) {
  _getAuthToken = getAuthToken;
}

export async function authFetch(url, options = {}) {
  const headers = { ...options.headers };

  if (_getAuthToken) {
    try {
      const token = await _getAuthToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    } catch {
      // Token fetch failed — request goes without auth
    }
  }

  return fetch(url, { ...options, headers });
}

export async function authPost(url, body) {
  return authFetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function authPatch(url, body) {
  return authFetch(url, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function authDelete(url) {
  return authFetch(url, { method: 'DELETE' });
}
